"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Googlereviewscta() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduced: "(prefers-reduced-motion: reduce)",
      normal: "(prefers-reduced-motion: no-preference)"
    }, context => {
      const {
        reduced
      } = context.conditions as {
        reduced: boolean;
      };
      if (reduced) {
        gsap.from([".tr-eyebrow", ".tr-heading", ".tr-body", ".tr-ctas"], {
          opacity: 0,
          duration: 0.2,
          stagger: 0.05,
          scrollTrigger: {
            trigger: container.current,
            start: "top 85%"
          }
        });
        return;
      }
      const tl = gsap.timeline({
        defaults: {
          ease: "power2.out"
        },
        scrollTrigger: {
          trigger: container.current,
          start: "top 80%"
        }
      });
      tl.from(".tr-eyebrow", {
        opacity: 0,
        y: 12,
        duration: 0.48
      }).from(".tr-heading", {
        opacity: 0,
        y: 20,
        duration: 0.64
      }, "+=0.12").from(".tr-body", {
        opacity: 0,
        y: 16,
        duration: 0.56
      }, "-=0.4").from(".tr-ctas > *", {
        opacity: 0,
        y: 14,
        duration: 0.5,
        stagger: 0.08
      }, "-=0.35");
    });
  }, {
    scope: container
  });
  return <section data-section-id="24686" ref={container} id="googlereviewscta" data-nav="light" className="bg-primary text-primary-foreground relative overflow-hidden py-24 md:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-end justify-center" aria-hidden="true">
        <svg viewBox="0 0 1400 300" className="w-full max-w-[1400px] opacity-[0.15]" preserveAspectRatio="xMidYEnd meet" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M0 220 L120 195 L200 210 L310 170 L420 200 L520 180 L640 215 L760 175 L880 205 L1000 185 L1120 210 L1240 190 L1400 215" />
          <path d="M0 260 L160 245 L280 255 L400 235 L540 250 L680 240 L820 258 L960 238 L1100 252 L1240 240 L1400 255" />
          <path d="M340 170 L360 140 L375 155 L395 125 L410 150 L430 170 Z" />
          <path d="M740 175 L760 145 L775 160 L795 130 L815 158 L835 175 Z" />
          <path d="M980 185 L1000 158 L1020 175 L1040 148 L1060 170 L1080 185 Z" />
        </svg>
      </div>

      <div className="relative mx-auto max-w-[900px] px-6 md:px-10 text-center">
        {}
        <div className="tr-eyebrow flex items-center justify-center gap-2">
          <span className="inline-block w-px h-[10px] bg-primary-foreground" aria-hidden="true" />
          <span className="font-sans font-semibold uppercase text-xs md:text-sm tracking-widest">
            Get Your Quote
          </span>
          <span className="inline-block w-px h-[10px] bg-primary-foreground" aria-hidden="true" />
        </div>

        {}
        <h2 className="tr-heading mt-7 font-serif font-bold text-primary-foreground" style={{
        fontSize: "clamp(2.5rem, 6vw, 5rem)",
        lineHeight: 1.02,
        letterSpacing: "-0.015em"
      }}>
          Ready for a clean home?
        </h2>

        {}
        <p className="tr-body mx-auto mt-6 font-sans text-primary-foreground/90" style={{
        fontSize: "clamp(1.125rem, 1.35vw, 1.375rem)",
        lineHeight: 1.55,
        maxWidth: "56ch"
      }}>
          Our network of professionals provides top-tier cleaning services. 
          Request your personalized quote today and experience the Summit difference.
        </p>

        {}
        <div className="tr-ctas mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
          <Button asChild size="lg" className="h-auto rounded-lg px-7 py-4 text-base font-semibold bg-background text-foreground hover:bg-background/90">
            <Link to="/GetAQuotePage">
              Get a personalized quote
              <ArrowRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="h-auto rounded-lg px-7 py-4 text-base font-semibold border-[1.5px] border-primary-foreground text-primary-foreground hover:bg-primary-foreground/10">
            <Link to="tel:3302031488">
              <Phone className="mr-1 h-4 w-4" />
              330 203 1488
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}